import {
  Component,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  EventEmitter,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";

@Component({
  selector: "custom-schema-form",
  templateUrl: "./schema-form.component.html",
  styleUrls: ["./schema-form.component.css"],
})
export class SchemaFormComponent implements OnChanges {
  @Input() schema: any;
  @Input() model: any = {};
  @Input() form: FormGroup = new FormGroup({});
  @Output() modelChange = new EventEmitter<any>();

  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["schema"] && this.schema) {
      let source = this.schema;
      if (this.schema.properties && !Array.isArray(this.schema)) {
        source = this.schema.properties;
      }

      this.fields = Array.isArray(source)
        ? [...source]
        : Object.keys(source).map((key) => ({
            key: key,
            ...source[key],
          }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/schema-form/schema-form.component.ts